import React from "react";
import { Link } from "react-router-dom";

const MyProjectCard = ({ project, handleDetail }) => {
  const { title, liveSite, clientRepo, serverRepo, image } = project;

  return (
    <div className="card shadow-slate-500 shadow-md p-2">
      <figure>
        <img className="h-64 w-full" src={image} alt="react project" />
      </figure>
      <div className="card-body">
        <h2 className="card-title">{title}</h2>
        <div className="card-actions justify-center mt-5 flex">
          <div className="badge badge-secondary">
            <a href={liveSite} target="_blank">
              Live
            </a>
          </div>
          <div className="badge badge-secondary">
            <a target="_blank" href={clientRepo}>
              Client Repo
            </a>
          </div>
          <div className="badge badge-secondary">
            <a target="_blank" href={serverRepo}>
              Server Repo
            </a>
          </div>
        </div>
        <Link
          onClick={() => handleDetail(project.id)}
          to="/details"
          state={project}
          className="btn btn-secondary mt-10"
        >
          Details
        </Link>
      </div>
    </div>
  );
};

export default MyProjectCard;
